import { Log } from 'core/infrastructure';
import { Cordova } from 'pos/common';
import * as SettingsProvider from './SettingsProvider';

export function start() {
	if (Cordova.isCordovaNavigator()) {
		uploadLog();
		setInterval(() => uploadLog(), 15 * 60 * 1000);
	}
}

function uploadLog() {
	// OJO: No se puede usar async/await y un catch normal porque no quiero bloquear el flujo de aplicación
	// mientras se ejecuta esto, y si en lugar de un await usas un void, el catch no capturará potenciales
	// errores al subir los logs y matará la aplicación
	Cordova.uploadFullLog(SettingsProvider.load())
		.catch((error: any) => Log.warn(`No ha sido posible enviar el log nativo ${error.message ?? error.toString?.() ?? JSON.stringify(error)}`));
}